import request from '@/utils/request';

export const getCustomerStatistics = (params: any) =>
  request({
    url: 'Dashboard/customer',
    method: 'GET',
    params
  });

export const exportCustomerStatistics = (params: any) =>
  request({
    url: 'Dashboard/exportCustomer',
    method: 'GET',
    params
  });
